<template>
  <div style="margin-bottom: 16px;" id="custom_social-form-group" class="alt-form-group multiple_checkbox2-form-group form-group">
    <label style="margin-bottom: 5px;" for="custom_social">{{ title }} <span class="required">*</span></label>
    <div class="multiple-checkbox-form-group pt_custom_filed">
      <div v-for="(social, index) in socialOptions" :key="index" class="checkbox-form-group-wrapper">
        <input
          type="checkbox"
          :id="`custom_social_` + social?.id"
          class="form-control custom-checkbox"
          :data-value="social.label"
          name="custom_social[]"
          v-model="selectedSocials[index].checked"

          @change="toggleInputField({
            key:props.type,
            value:social.key,
            type:social.key,
            label:social.label
          },index)"
        />
        <svg style="margin-top:1px">
          <use xlink:href="#checkmark-custom_social"></use>
        </svg>
        <label style="font-size: 14px;
    color: #212529;text-transform: none;
    font-size: 14px;
    color: rgb(33, 37, 41);
    text-transform: none;
    display: inline-block;
    margin-top: 3px;
    " :for="'custom_social_' + social?.id">{{ social.label }}</label>
        <svg xmlns="http://www.w3.org/2000/svg" style="display: none">
          <symbol id="checkmark-custom_social" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-miterlimit="10" fill="none" d="M22.9 3.7l-15.2 16.6-6.6-7.1"></path>
          </symbol>
        </svg>
        <div style="margin-top:1rem" v-if="selectedSocials[index].checked && social.isShowInput === 1">
                 <p class="other-field" style="margin-bottom: 0;">{{ label }}<span class="required">*</span></p>
        <input
          @keyup="validateField(index)"
          
          type="text"
          class="form-control"
          :class="'pt_custom_social_' + social?.id"
          v-model="selectedSocials[index].value"
          @change="()=>emit('setInputValue',{
            key:social.key,
            label:social.label,
            value:selectedSocials[index].value
          })"
          :placeholder="'@xyz123 *'"

        />
        </div>
 
        <!-- <span v-if="errors[index]" class="error_custom">{{ errors[index] }}</span> -->
      </div>
    </div>
    <label style="font-size: 14px;
    color: #DC0F1D;" v-if="errorMessage" :for="id" class="error">{{ errorMessage}}</label>

  </div>
</template>

<script setup>
import { ref, reactive, watch } from 'vue';

const props = defineProps({
  type: String, 
  options: Array,
  title: String,
  errorOther:String | null,
  errorMessage: String | null,
  label: String | null
});
const emit = defineEmits(['checkOptions','setInputValue']);
const socialOptions = ref([]);
const selectedSocials = ref([]);
const errors = ref({});
onMounted(() => {
  if (props.options) {
    socialOptions.value = props.options;
    // Initialize selectedSocials with empty values
    selectedSocials.value = socialOptions.value.map(() => ({
      checked: false,
      value: ''
    }));
  }
})
const click = (e) => {
  emit('checkOptions', e);
}
const toggleInputField = (e,index) => {
  // if(e.value === 'other_social' || e.value === 'other_referral'){
  //   emit('setInputValue', {
  //     ...e,value :selectedSocials[index].value,
  //   });
  // }else{
    emit('checkOptions', e);
  // }
  // emit('checkOptions', e);
  const inputField = document.querySelector('.pt_custom_social_' + index);
  if (inputField) {
    inputField.style.display = selectedSocials.value[index].checked ? 'block' : 'none';
  }
  props.errorMessage = null;
};
const validateField = (index) => {
  if (selectedSocials.value[index].checked && !selectedSocials.value[index].value) {
    errors.value[index] = `Please enter your ${socialOptions.value[index].label} handle`;
  } else {
    errors.value[index] = null;
    props.errorMessage = null;
  }
};

// Form submission logic to validate all selected fields
const validateForm = () => {
  errors.value = {};
  selectedSocials.value.forEach((social, index) => {
    if (social.checked && !social.value && social.isShowInput === 1) {
      errors.value[index] = `Please enter your ${socialOptions.value[index].label} handle`;
    }
  });
  return Object.keys(errors.value).length === 0;
};
</script>
<style scoped>
.other-field {
  font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    margin-bottom: 5px;
    color: #212529;
    text-align: left;
    display: block;
    text-transform: uppercase;
}
</style>
